// refs value depends on environment variables

const environmentVars = {
  SIGN_IN_PATH: process.env.SIGN_IN_PATH,
  SIGN_UP_PATH: process.env.SIGN_UP_PATH,
  TERMS_PATH: process.env.TERMS_PATH,
  PRIVACY_PATH: process.env.PRIVACY_PATH,
  SUPPORT_PATH: process.env.SUPPORT_PATH,
  SUBSCRIPTION_TERMS_PATH: process.env.SUBSCRIPTION_TERMS_PATH,
  PAYMENT_GROUP: process.env.PAYMENT_GROUP
}

export function applyReferenceHrefs() {
  document.querySelectorAll("[data-reference]").forEach((item) => {
    item.href = environmentVars[item.dataset.reference];
  });
}

applyReferenceHrefs();

export function setSearchParams() {
  document.querySelectorAll("[data-external-reference]").forEach((item) => {
    const searchParamsString =
      window.__customAnalytics__ && window.__customAnalytics__.searchParams;
    const searchParams = new URLSearchParams(searchParamsString || "");
    const externalId = searchParams.get("externalId");
    if (externalId) {
      searchParams.delete("externalId");
      externalId && searchParams.set("external_id", externalId);
    }
    environmentVars.PAYMENT_GROUP &&
      searchParams.set("payment_group", environmentVars.PAYMENT_GROUP);

    if (searchParams) {
      item.href = `${environmentVars[item.dataset.reference]}?${searchParams}`;
    }
  });
}
